import React from 'react';
import * as S from './legalStyles';

const TermsContentKo: React.FC = () => (
  <>
    <div style={{
      background: '#fffbeb', border: '2px solid #fcd34d', borderRadius: '12px',
      padding: '20px', marginBottom: '30px',
    }}>
      <h3 style={{ color: '#92400e', marginBottom: '10px' }}>⚠️ 중요 안내 - 직접거래 플랫폼</h3>
      <ul style={{ color: '#a16207', margin: 0, paddingLeft: '20px', lineHeight: '1.8' }}>
        <li><strong>Freematch는 전문가와 의뢰자를 연결하는 중개 플랫폼입니다.</strong></li>
        <li>모든 거래는 당사자 간 직접 진행되며, 플랫폼은 거래에 개입하지 않습니다.</li>
        <li>결제, 환불, 분쟁은 당사자 간 해결해야 합니다.</li>
        <li>플랫폼 거래 수수료는 0%입니다.</li>
      </ul>
    </div>

    <section style={S.section}>
      <h2 style={S.h2}>제1조 (목적)</h2>
      <p style={S.p}>
        이 약관은 Freematch(이하 "회사")가 제공하는 프리랜서 매칭 서비스(이하 "서비스")의
        이용조건 및 절차, 회사와 회원 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>제2조 (정의)</h2>
      <ul style={S.ul}>
        <li><strong>"서비스"</strong>: 회사가 제공하는 프리랜서-의뢰인 연결 플랫폼</li>
        <li><strong>"회원"</strong>: 본 약관에 동의하고 서비스를 이용하는 자</li>
        <li><strong>"의뢰자"</strong>: 프로젝트를 등록하고 전문가를 찾는 회원</li>
        <li><strong>"전문가"</strong>: 서비스를 등록하고 프로젝트를 수행하는 회원</li>
        <li><strong>"직접거래"</strong>: 의뢰자와 전문가가 플랫폼 외부에서 직접 결제하는 방식</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>제3조 (서비스의 제공)</h2>
      <p style={S.p}>회사는 다음과 같은 서비스를 제공합니다:</p>
      <ul style={S.ul}>
        <li>프로젝트 등록 및 검색</li>
        <li>서비스(전문가 프로필) 등록 및 검색</li>
        <li>의뢰자-전문가 간 실시간 채팅</li>
        <li>거래 상태 관리 (거래중/거래완료)</li>
        <li>리뷰 및 평점 시스템</li>
        <li>AI 에이전트 도구 (AI 제안서 초안, AI 계약서 초안, AI 전문가 분석 리포트)</li>
      </ul>
      <p style={{ ...S.p, marginTop: '10px' }}>
        <strong>※ 회사는 결제 중개 서비스를 제공하지 않습니다.</strong> 모든 결제는 당사자 간 직접 진행됩니다.
      </p>
    </section>

    <section style={{ ...S.section, background: '#f0fdf4', padding: '20px', borderRadius: '12px', border: '1px solid #86efac' }}>
      <h2 style={{ ...S.h2, color: '#166534' }}>제4조 (직접거래 및 플랫폼의 역할)</h2>
      <p style={{ ...S.p, color: '#15803d' }}>
        ① <strong>회사는 통신판매중개자로서 거래 당사자가 아닙니다.</strong><br/>
        ② 회사는 의뢰자와 전문가를 연결하는 플랫폼 서비스만 제공합니다.<br/>
        ③ 모든 거래(계약, 결제, 작업 수행)는 당사자 간 직접 진행됩니다.<br/>
        ④ 회사는 거래 금액을 수취하거나 중개하지 않습니다.<br/>
        ⑤ 회사는 거래 상태(거래중/거래완료)만 플랫폼에서 표시합니다.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>제5조 (플랫폼 수수료)</h2>
      <p style={S.p}>
        ① <strong>회사는 거래 수수료를 부과하지 않습니다 (0%).</strong><br/>
        ② AI 제안서 초안·AI 계약서 초안·AI 전문가 분석 리포트는 구독이 아닌 건당 결제(490원) 또는 12건 묶음(4,990원) 이용권 방식으로 제공됩니다.<br/>
        ③ 이용권 결제는 웹사이트(PC 또는 웹 브라우저)에서 진행되며, 결제 후 즉시 이용 가능합니다. 이용권은 성사 여부와 무관한 도구 이용료로, 환불은 이용 전 잔여 건에 한해 가능합니다.
      </p>
    </section>

    <section style={{ ...S.section, background: '#fef2f2', padding: '20px', borderRadius: '12px', border: '1px solid #fca5a5' }}>
      <h2 style={{ ...S.h2, color: '#991b1b' }}>제6조 (면책조항) ⚠️</h2>
      <p style={{ ...S.p, color: '#dc2626' }}>
        ① <strong>회사는 회원 간 거래에서 발생한 분쟁, 손해, 피해에 대해 책임을 지지 않습니다.</strong><br/>
        ② 결제, 환불, 취소 등 모든 금전 관련 사항은 당사자 간 해결해야 합니다.<br/>
        ③ 회사는 회원이 게재한 정보의 정확성, 신뢰성을 보증하지 않습니다.<br/>
        ④ 전문가 검증(4대보험 등)은 참고용이며, 회사가 보증하지 않습니다.<br/>
        ⑤ 회원은 거래 전 상대방의 신원과 능력을 스스로 확인해야 합니다.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>제7조 (안전한 거래를 위한 권장사항)</h2>
      <p style={S.p}>회사는 안전한 거래를 위해 다음을 권장합니다:</p>
      <ul style={S.ul}>
        <li>선금/잔금 방식으로 결제하세요 (예: 30% 선금, 70% 완료 후)</li>
        <li>카카오페이, 토스 등 기록이 남는 결제 수단을 사용하세요</li>
        <li>작업 범위와 일정을 채팅으로 명확히 합의하세요</li>
        <li>중간 결과물을 확인하고 피드백하세요</li>
        <li>작업 완료 후 "거래완료" 버튼을 눌러 기록을 남기세요</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>제8조 (회원의 의무)</h2>
      <p style={S.p}>회원은 다음 행위를 하여서는 안 됩니다:</p>
      <ul style={S.ul}>
        <li>타인의 정보 도용</li>
        <li>허위 프로필 또는 포트폴리오 등록</li>
        <li>회사 및 제3자의 저작권 등 지적재산권 침해</li>
        <li>사기, 기망 등 부정한 거래 행위</li>
        <li>외설 또는 폭력적인 내용의 게시</li>
        <li>기타 불법적이거나 부당한 행위</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>제9조 (회원 탈퇴 및 자격 상실)</h2>
      <p style={S.p}>
        ① 회원은 언제든지 탈퇴를 요청할 수 있으며, 회사는 즉시 처리합니다.<br/>
        ② 회원이 본 약관을 위반한 경우 회사는 회원 자격을 제한 또는 정지시킬 수 있습니다.<br/>
        ③ 진행 중인 거래가 있는 경우, 상대방과 협의 후 탈퇴하시기 바랍니다.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>제10조 (분쟁해결)</h2>
      <p style={S.p}>
        ① 회원 간 거래 분쟁은 당사자 간 협의로 해결해야 합니다.<br/>
        ② 회사는 분쟁 중재 서비스를 제공하지 않습니다.<br/>
        ③ 본 약관에 명시되지 않은 사항은 관계 법령에 따릅니다.<br/>
        ④ 서비스 이용으로 발생한 분쟁에 대해서는 회사 소재지 관할 법원을 전속 관할로 합니다.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>사업자 정보</h2>
      <p style={S.p}>
        <strong>상호:</strong> KUNKONG<br/>
        <strong>대표자:</strong> 박기범<br/>
        <strong>사업자등록번호:</strong> 306-38-75095<br/>
        <strong>주소:</strong> 경기도 화성시 왕배산1길 3-4, 3층<br/>
        <strong>대표전화:</strong> 010-6284-2450<br/>
        <strong>이메일:</strong> kunkong.co@gmail.com
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>부칙</h2>
      <p style={S.p}>이 약관은 2026년 1월 29일부터 시행됩니다.</p>
    </section>
  </>
);

export default TermsContentKo;
